import { Page } from '@lib/queries';
import { getConstants, getPage } from '@lib/sanity';

import { TextBlock } from '../components/text-block';

import type { Constants } from '@lib/queries';
import type { GetServerSideProps } from 'next';

import { setAppContext } from '~/components/context';
import { PageWrapper } from '~/components/wrapper';

type Props = { page: Page; context: Constants };

const Page = ({ page, context }: Props) => {
  setAppContext(context);

  return (
    <PageWrapper>
      <TextBlock {...page.content} />
    </PageWrapper>
  );
};

type Params = { slug: string };

export const getServerSideProps: GetServerSideProps<Props, Params> = async ({ params }) => {
  const page = await getPage(params?.slug ?? '');
  const context = await getConstants();

  return {
    props: { page, context },
  };
};

export default Page;
